import React, { FC } from 'react';

import { useSmokingWarningText } from '@/scenarios/legacy-player/components/PlayerSkin/parts/AgeRestriction/useSmokingWarningText';

import { AgeRestrictionContainer } from '../../feature-player/ui/skin/age-restriction/container';
import { getVideoSize } from '../../movie-player/utils/get-video-size';
import { useFilmOtt } from '../hooks/use-film-ott';
import { useFilmAgeRestriction } from '../hooks/use-film-age-restriction';
import { useFilmCurrentStream } from '../hooks/use-film-current-stream';

interface FilmAgeRestrictionProps {
    contentId: string;
}

export const FilmAgeRestriction: FC<FilmAgeRestrictionProps> = ({ contentId }) => {
    const ageRestriction = useFilmAgeRestriction(contentId);
    const currentStream = useFilmCurrentStream(contentId);

    const ott = useFilmOtt(contentId);
    const hasSmokingScenes = ott?.hasSmokingScenes ?? undefined;

    const smokingWarningText = useSmokingWarningText('film');

    const { videoHeight, videoWidth } = getVideoSize(currentStream);

    return (
        <AgeRestrictionContainer
            age={ageRestriction}
            videoHeight={videoHeight}
            videoWidth={videoWidth}
            smokingWarningText={hasSmokingScenes ? smokingWarningText : undefined}
        />
    );
};
